import * as Yup from 'yup';

const RecordSchema = Yup.object().shape({
    language: Yup.string()
        .min(1, 'Too Short!')
        .max(150, 'Too Long!')
        .required('Required'),
    helpPromptDelaySeconds: Yup.number()
        .min(30, 'Minimum 30 seconds')
        .max(600, 'Maximum 600 seconds')
        .optional(),
});

export default RecordSchema;
